<!--
 * @Description: 跟进记录详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-05-05 13:42:20
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="base" tab="基本信息">
            <baseMessage :disabled="true" view @getDetail="getDetail" />
            <dc-layout-card title="评论记录" :isAutoLayout="false">
      <span v-if="detail.score > 0">
              <a-rate style="margin-bottom: 16px;margin-top: -10px;" v-model:value="detail.score"
                      :tooltips="commentDesc" :disabled="true"/>
              <span class="ant-rate-text">{{ commentDesc[detail.score - 1] }}</span>
            </span>
              <commitList
                ref="commitListRef"
                :permissionPage="{
           delCommit: type === 'view' ? 'lbu_follow_view_del_commit' : 'lbu_follow_list_del_commit'
          }"
                :data="detail.commentList"
                :id="route.query.id"
              />
            </dc-layout-card>
<!--            <commitList-->
<!--              ref="commitListRef"-->
<!--              :permissionPage="{-->
<!--                delCommit: type === 'view' ? 'lbu_follow_view_del_commit' : 'lbu_follow_list_del_commit'-->
<!--              }"-->
<!--              :data="detail.commentList"-->
<!--              :id="route.query.id"-->
<!--            />-->
            <a-form name="detailsForm" ref="formRef" :model="form" v-if="commentComputed">
              <dc-layout-card title="评论">
                 <span v-if="detail.score <= 0">
              <a-rate style="margin-left: 20px;margin-bottom: 16px;margin-top: -10px;" v-model:value="form.score" :tooltips="commentDesc" :disabled="detail.score > 0" />
              <span class="ant-rate-text">{{ commentDesc[form.score - 1] }}</span>
            </span>
                <a-col :span="24">
                  <Editor
                    v-model:value="form.content"
                    :maxlength="3000"
                    v-model:mention="form.userCodes"
                    placeholder="请输入评论"
                  />
                </a-col>
                <dc-form-item label="上传附件" name="fileId" :span="24">
                  <UploadFile v-model:value="form.fileId" valueType="array" />
                </dc-form-item>
              </dc-layout-card>
            </a-form>
          </a-tab-pane>
          <a-tab-pane key="operationLog" tab="操作日志">
            <TabsOperationLog
              returnPath="/lbu/followUpRecord"
              tableId="LbuFollowUpOperationLog"
              appId="cos_lbu"
              :resourceId="route.query.id"
            />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <cos-footer-button :loading="loading" hideOk>
        <a-button
          v-show="commentComputed && activeKey === 'base'"
          type="primary"
          @click="handleCommit"
          :loading="loading"
          v-permission="'lbu_follow_comment_btn'"
          >发表</a-button
        >
        <template v-if="type === 'view'">
          <a-button
            v-show="!commentComputed && activeKey === 'base'"
            @click="showCommentFrom"
            :loading="loading"
            v-permission="'lbu_follow_comment_btn'"
            >评论</a-button
          >
          <a-button
            type="primary"
            @click="handleEdit"
            :loading="loading"
            v-permission="'lbu_follow_edit_btn'"
            >编辑</a-button
          >
        </template>
      </cos-footer-button>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'
import baseMessage from '../components/baseMessage.vue'
import commitList from '../components/commitList.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import Editor from '@/components/Editor'
import UploadFile from '@/components/UploadFile'
import { DcMessage } from '@dc-platform/dc-components'
import { followRecordsAddComment } from '@/api/yuntuSales/followUpManage'
import type { commentItem, LbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
import { useRoute, useRouter } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
const router = useRouter()
const route = useRoute()
const form = ref<commentItem>({
  fileId: []
})
const props = defineProps({
  type: {
    default: String
  }
})
const activeKey = ref('base')
const loading = ref(false)
const detail = ref({})
const commitListRef = ref()
const commentDesc = ref<string[]>(['非常不满意', '不满意', '一般', '满意', '非常满意'])
const showComment = ref(false)
const commentComputed = computed(() => {
  if (props.type === 'comment') {
    return true
  }
  return showComment.value
})
//
const showCommentFrom = () => {
  showComment.value = true
  // setTimeout(() => {
  //   const h = document.body.clientHeight
  //   window.scrollTo({
  //     top: h
  //     // behavior: 'smooth'
  //   })
  // }, 50)
}
const handleCommit = () => {
  if (!form.value.content) {
    // const h = document.getElementById('app')?.scrollHeight
    // document.getElementById('app')?.scrollTo({
    //   top: h,
    //   behavior: 'smooth'
    // })
    DcMessage.warning('请输入评论内容')
    return
  }
  loading.value = true
  // 评论必填
  followRecordsAddComment({
    followId: route.query.id,
    ...form.value
  })
    .then((res) => {
      DcMessage.success('发表成功')
      layoutTags.close()
    })
    .finally(() => {
      loading.value = false
    })
}
const getDetail = (data: LbuFollowUpRecordEdit) => {
  detail.value = data
}
const handleEdit = () => {
  router.push({
    path: '/lbu/followUpRecord/edit',
    query: {
      id: route.query.id
    }
  })
}
</script>
<script lang="ts">
export default {
  name: 'DcCosLbuFollowUpRecordCommit'
}
</script>
